export enum DocumentTypesEnum {
  // SATINALMA FATURA VE İRSALİYELERİ
  PURCHASE_INVOICE = "PURCHASE_INVOICE",
  PURCHASE_RETURN_INVOICE = "PURCHASE_RETURN_INVOICE",
  PURCHASE_RECEIVE_SERVICE_INVOICE = "PURCHASE_RECEIVE_SERVICE_INVOICE",
  PURCHASE_RECEIVE_PROFORMA_INVOICE = "PURCHASE_RECEIVE_PROFORMA_INVOICE",
  PURCHASE_PRICE_DIFF_INVOICE = "PURCHASE_PRICE_DIFF_INVOICE",
  PURCHASE_PRODUCER_INVOICE = "PURCHASE_PRODUCER_INVOICE",

  PURCHASE_DISPATCH = "PURCHASE_DISPATCH",
  PURCHASE_RETURN_DISPATCH = "PURCHASE_RETURN_DISPATCH",
  PURCHASE_CONSIGNMENT_DISPATCH = "PURCHASE_CONSIGNMENT_DISPATCH",
  PURCHASE_CONSIGNMENT_RETURN_DISPATCH = "PURCHASE_CONSIGNMENT_RETURN_DISPATCH",
  PURCHASE_PRODUCER_DISPATCH = "PURCHASE_PRODUCER_DISPATCH",

  // SATIŞ FATURA VE İRSALİYELERİ
  SALES_RETAIL_INVOICE = "SALES_RETAIL_INVOICE",
  SALES_RETAIL_RETURN_INVOICE = "SALES_RETAIL_RETURN_INVOICE",
  SALES_WHOLESALE_INVOICE = "SALES_WHOLESALE_INVOICE",
  SALES_WHOLESALE_RETURN_INVOICE = "SALES_WHOLESALE_RETURN_INVOICE",
  SALES_GIVEN_SERVICE_INVOICE = "SALES_GIVEN_SERVICE_INVOICE",
  SALES_GIVEN_PROFORMA_INVOICE = "SALES_GIVEN_PROFORMA_INVOICE",
  SALES_PRICE_DIFF_INVOICE = "SALES_PRICE_DIFF_INVOICE",

  SALES_RETAIL_DISPATCH = "SALES_RETAIL_DISPATCH",
  SALES_RETAIL_RETURN_DISPATCH = "SALES_RETAIL_RETURN_DISPATCH",
  SALES_WHOLESALE_DISPATCH = "SALES_WHOLESALE_DISPATCH",
  SALES_WHOLESALE_RETURN_DISPATCH = "SALES_WHOLESALE_RETURN_DISPATCH",
  SALES_CONSIGNMENT_DISPATCH = "SALES_CONSIGNMENT_DISPATCH",
  SALES_CONSIGNMENT_RETURN_DISPATCH = "SALES_CONSIGNMENT_RETURN_DISPATCH",

  // CARİ HESAP
  SELLER = "SELLER",
  CUSTOMER = "CUSTOMER",
  CUSTOMER_SELLER = "CUSTOMER_SELLER",
  MAIN_CUSTOMER = "MAIN_CUSTOMER",

  // CARİ HESAP FİŞLERİ
  CURR_ACCOUNT_CASH_COLLECTION = "CURR_ACCOUNT_CASH_COLLECTION",
  CURR_ACCOUNT_CASH_PAYMENT = "CURR_ACCOUNT_CASH_PAYMENT",
  CURR_ACCOUNT_DEBIT_NOTE = "CURR_ACCOUNT_DEBIT_NOTE",
  CURR_ACCOUNT_CREDIT_NOTE = "CURR_ACCOUNT_CREDIT_NOTE",
  CURR_ACCOUNT_REMITTANCE_RECEIPT = "CURR_ACCOUNT_REMITTANCE_RECEIPT",
  CURR_ACCOUNT_EXCHANGE_DIFFERENCE_RECEIPT = "CURR_ACCOUNT_EXCHANGE_DIFFERENCE_RECEIPT",
  CURR_ACCOUNT_CREDIT_CARD_RECEIPT = "CURR_ACCOUNT_CREDIT_CARD_RECEIPT",
  CURR_ACCOUNT_CREDIT_CARD_RETURN_RECEIPT = "CURR_ACCOUNT_CREDIT_CARD_RETURN_RECEIPT",

  // MALZEME YÖNETİM FİŞLERİ
  MATERIAL_WAREHOUSE_TRANSFER_RECEIPT = "MATERIAL_WAREHOUSE_TRANSFER_RECEIPT",
  MATERIAL_WAREHOUSE_INPUT_RECEIPT = "MATERIAL_WAREHOUSE_INPUT_RECEIPT",
  MATERIAL_WAREHOUSE_OUTPUT_RECEIPT = "MATERIAL_WAREHOUSE_OUTPUT_RECEIPT",
  MATERIAL_EXCESS_STOCK_RECEIPT = "MATERIAL_EXCESS_STOCK_RECEIPT",
  MATERIAL_SHORTAGE_STOCK_RECEIPT = "MATERIAL_SHORTAGE_STOCK_RECEIPT",
  MATERIAL_USAGE_RECEIPT = "MATERIAL_USAGE_RECEIPT",
  MATERIAL_SCRAP_RECEIPT = "MATERIAL_SCRAP_RECEIPT",

  // FİNANS KASA FİŞLERİ
  CASH_ACCOUNT_OPENING_RECEIPT_DEBIT = "CASH_ACCOUNT_OPENING_RECEIPT_DEBIT",
  CASH_ACCOUNT_OPENING_RECEIPT_CREDIT = "CASH_ACCOUNT_OPENING_RECEIPT_CREDIT",
  CASH_ACCOUNT_REMITTANCE_RECEIPT_DEBIT = "CASH_ACCOUNT_REMITTANCE_RECEIPT_DEBIT",
  CASH_ACCOUNT_REMITTANCE_RECEIPT_CREDIT = "CASH_ACCOUNT_REMITTANCE_RECEIPT_CREDIT",
  CASH_ACCOUNT_EXCHANGE_DIFFERENCE_RECEIPT_DEBIT = "CASH_ACCOUNT_EXCHANGE_DIFFERENCE_RECEIPT_DEBIT",
  CASH_ACCOUNT_EXCHANGE_DIFFERENCE_RECEIPT_CREDIT = "CASH_ACCOUNT_EXCHANGE_DIFFERENCE_RECEIPT_CREDIT",
  CASH_ACCOUNT_CURRENTACCOUNT_COLLECTION = "CASH_ACCOUNT_CURRENTACCOUNT_COLLECTION",
  CASH_ACCOUNT_CURRENTACCOUNT_PAYMENT = "CASH_ACCOUNT_CURRENTACCOUNT_PAYMENT",

  // FİYAT DEĞİŞİM FİŞLERİ
  RETAIL_PURCHASE_SALES_PRICE_CHANGE_RECEIPT = "RETAIL_PURCHASE_SALES_PRICE_CHANGE_RECEIPT",
  RETAIL_PURCHASE_PRICE_CHANGE_RECEIPT = "RETAIL_PURCHASE_PRICE_CHANGE_RECEIPT",
  RETAIL_SALES_PRICE_CHANGE_RECEIPT = "RETAIL_SALES_PRICE_CHANGE_RECEIPT",

  // Banka FİŞLERİ
  BANK_ACCOUNT_RECEIPT = "BANK_ACCOUNT_RECEIPT",
  BANK_ACCOUNT_REMITTANCE_RECEIPT = "BANK_ACCOUNT_REMITTANCE_RECEIPT",
  BANK_ACCOUNT_INCOMING_REMITTANCE_RECEIPT = "BANK_ACCOUNT_INCOMING_REMITTANCE_RECEIPT",
  BANK_ACCOUNT_SENT_REMITTANCE_RECEIPT = "BANK_ACCOUNT_SENT_REMITTANCE_RECEIPT",
  BANK_ACCOUNT_OPENING_RECEIPT = "BANK_ACCOUNT_OPENING_RECEIPT",
  BANK_ACCOUNT_EXCHANGE_DIFFERENCE_RECEIPT = "BANK_ACCOUNT_EXCHANGE_DIFFERENCE_RECEIPT",

  // DİĞER
  TRANSFERRER_BALANCE = "TRANSFERRER_BALANCE",

  VIRTUAL_ORDER = "VIRTUAL_ORDER",
}
